export class BOHealthTechnologyMedicamentDoseTaken{
    id:number;
    quantity:number;
    measurementMedicationUnits:string;
}